import 'dayjs/locale/it';

import { LocalizationProviderProps } from '@mui/x-date-pickers';
import { useAuth } from '@src/hooks';

type UseCGTLocalizationProviderPropsReturn = {
    extraProps: Omit<LocalizationProviderProps, 'dateAdapter'>;
};

export const useCGTLocalizationProviderProps = (): UseCGTLocalizationProviderPropsReturn => {
    const { sessionData } = useAuth();

    const isCGT = sessionData?.attributes?.company?.startsWith('cgt');

    const extraProps: UseCGTLocalizationProviderPropsReturn['extraProps'] = {
        adapterLocale: 'it',
    };

    return {
        extraProps: isCGT ? extraProps : {},
    };
};
